<template>
  <div class="manageFlagContainer">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="changeManageFlag"
          icon
          small
          :color="color"
          min-width="0"
          v-bind="attrs"
          v-on="on"
          text
          @click.native="switchManageFlag()"
        >
          <v-icon>{{icon}}</v-icon>
        </v-btn>
        <v-icon
          v-else
          v-bind="attrs"
          v-on="on"
          :color="color"
        >{{icon}}</v-icon>
      </template>
      <span>{{ text }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "manage-config-flag",
  props: {
    canEdit: false,
    changeManageFlag: false,
    value: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      manageFlag: 0,
      color: "success",
      icon: "",
      text: "",
    };
  },
  watch: {
    value: function (newVal, oldVal) {
      // watch it
      this.manageFlag = newVal;
      this.loadComponent();
    },
  },
  mounted() {
    this.manageFlag = this.value;
    this.loadComponent();
  },
  methods: {
    switchManageFlag() {
      if (this.canEdit) {
        this.manageFlag += 1;
        if (this.manageFlag > 2) this.manageFlag = 0;
        this.$emit("input", this.manageFlag);
      }
    },
    loadComponent() {
      if (!this.canEdit) {
        this.color = "error";
        this.icon = "mdi-cancel";
        this.text = this.$t("configuration_managed_by_ente");
        return;
      }
      if (this.manageFlag == 0) {
        this.color = "success";
        this.icon = "mdi-pencil";
        this.text = this.$t("configuration_not_inherited");
      }
      if (this.manageFlag === 1) {
        this.color = "warning";
        this.icon = "mdi-download";
        this.text = this.$t("configuration_inherited_and_editable");
      }
      if (this.manageFlag === 2) {
        this.color = "error";
        this.icon = "mdi-download-off";
        this.text = this.$t("configuration_forced_in_club");
      }
    },
  },
};
</script>
<style scoped>
.manageFlagContainer {
  float: left;
}
</style>